import * as types from 'models/actionTypes'
import { getDebugFurnitureId, getDebugFurnitureModelUrl, getRegion, getSubCatalog } from 'models/location/selectors'
import { clearFurnitureFilter, requestFurniture, updateFurnitureFilter } from 'models/furniture/actions'
import { getFilter, getFilterResult, getStackEnabled } from 'models/furniture/selectors'
import { DEBUG_CATEGORY } from 'models/furniture/constants'
import { LOCALE_GEO } from 'models/location/constants'
import { getSelectedSceneRoomType } from 'models/compositions/selectors'

const furnitureMiddleware = (store) => (next) => (action) => {
    switch (action.type) {
        case types.REQUEST_FURNITURE_SAGA: {
            const state = store.getState()

            const { moreToken, currentPage } = getFilterResult(state)
            const requestedPage = currentPage + 1

            const stackEnabled = getStackEnabled(state)

            const filter = Object.fromEntries(
                Object.entries(getFilter(state)).filter(([, val]) => !!val && val !== '*'),
            )

            // Special case for debug furniture
            if (filter.category === DEBUG_CATEGORY) {
                delete filter.category
                filter.region = LOCALE_GEO
            } else {
                filter.region = getRegion(state)
            }

            filter.stackEnabled = stackEnabled

            const debugModelUrl = getDebugFurnitureModelUrl(state)
            const debugFurnitureId = getDebugFurnitureId(state)

            return next({
                ...action,
                filter,
                moreToken,
                requestedPage,
                debugModelUrl,
                debugFurnitureId,
            })
        }
        case types.REQUEST_FURNITURE_CATEGORIES_SAGA: {
            const state = store.getState()
            return next({
                ...action,
                region: getRegion(state),
                stackEnabled: getStackEnabled(state),
            })
        }
        case types.FURNITURE_FILTER_CLEAR:
        case types.FURNITURE_FILTER_UPDATE: {
            const result = next(action)
            store.dispatch(requestFurniture())
            return result
        }
        case types.FILTER_FEATURED_PRODUCTS: {
            const state = store.getState()
            const urlSubCatalog = getSubCatalog(state)
            const roomType = getSelectedSceneRoomType(state)

            if (urlSubCatalog) {
                store.dispatch(updateFurnitureFilter({ subCatalog: urlSubCatalog }))
            } else if (roomType) {
                store.dispatch(updateFurnitureFilter({ roomType }))
            } else {
                store.dispatch(clearFurnitureFilter())
            }

            return next(action)
        }
        default:
            return next(action)
    }
}

export default furnitureMiddleware
